export default "__VITE_ASSET__bcf93dec__"